import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface KnowledgeGraphNode {
  id: string;
  label: string;
  name: string;
  documentId?: string | null;
  metadata?: string | null;
}

export interface KnowledgeGraphEdge {
  id: string;
  source: string;
  target: string;
  type: string;
  relationship: string;
  documentName?: string | null;
}

export interface KnowledgeGraphMeta {
  nodeCount: number;
  edgeCount: number;
  hasMoreNodes: boolean;
  totalNodeCount?: number | null;
}

export interface KnowledgeGraphResponse {
  scope: 'combined' | 'document';
  documentName: string | null;
  nodes: KnowledgeGraphNode[];
  edges: KnowledgeGraphEdge[];
  meta: KnowledgeGraphMeta;
}

export interface KnowledgeGraphDocumentItem {
  name: string;
  documentId?: string | null;
  updatedAt?: string | null;
}

export interface KnowledgeGraphDocumentsResponse {
  documents: KnowledgeGraphDocumentItem[];
}

@Injectable({
  providedIn: 'root'
})
export class KnowledgeGraph {
  private baseUrl = `${environment.apiUrl}/knowledge-graph`;

  constructor(private http: HttpClient) {}

  getDocuments(): Observable<KnowledgeGraphDocumentsResponse> {
    return this.http.get<KnowledgeGraphDocumentsResponse>(`${this.baseUrl}/documents`);
  }

  getGraph(params?: {
    documentName?: string;
    nodeOffset?: number;
    limitNodes?: number;
    limitEdges?: number;
    includeMentions?: boolean;
  }): Observable<KnowledgeGraphResponse> {
    let httpParams = new HttpParams()
      .set('node_offset', String(params?.nodeOffset ?? 0))
      .set('limit_nodes', String(params?.limitNodes ?? 300))
      .set('limit_edges', String(params?.limitEdges ?? 20000))
      .set('include_mentions', String(params?.includeMentions ?? false));

    if (params?.documentName) {
      httpParams = httpParams.set('document_name', params.documentName);
    }

    return this.http.get<KnowledgeGraphResponse>(this.baseUrl, { params: httpParams });
  }
}
